function contactNamePhone(phone_number) {
  if (phone_number.match(/^[0-9]/)) {
    return '+' + phone_number
  }
  return phone_number
}

export default function contactName({phone_number, contact: c}) {
  if (!c) return contactNamePhone(phone_number);

  if (c.name.length) return c.name;

  const name = fullName(c);
  if (name.length) return name;

  return contactNamePhone(phone_number);
}

export function fullName(c) {
  return ['last_name', 'first_name', 'second_name'].map(k => c[k]).join(' ').trim();
}
